import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { nameregex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import { GrUploadOption } from "react-icons/gr";
import { addFerry } from "../store/slices/ferry";

const AddFerries = () => {
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;
  const [name, setName] = useState("");
  const [image, setimage] = useState("");
  const [imageError, setImageError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [previewImage, setPreviewImage] = useState(""); // New state for image preview
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    switch (name) {
      case "name":
        setName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter a valid ferry name"
            : "";
        break;

      default:
        break;
    }

    setErrors(validationErrors);
  };

  const addFerriess = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    setTimeout(() => setIsDisabled(false), 3000);

    const validationErrors = {};

    // Validate name
    if (!name.trim()) {
      validationErrors.name = "Please enter name";
    } else if (!nameregex.test(name)) {
      validationErrors.name = "Name must be at least three characters";
    }

    // Validate image
    if (!image) {
      validationErrors.image = "Please upload an image";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const item = {
      name,
      image,
    };

    try {
      await dispatch(addFerry(item)).unwrap();
      alert("Ferry service added successfully!");
      navigate("/admin/ferry-services");
    } catch (error) {
      alert(error);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  async function imageUpload(e) {
    setImageError("");
    const file = e.target.files[0];

    if (!file) {
      setImageError("Please select a file to upload");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setImageError("Please upload an image less than 5 MB");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        "x-access-token": token,
      },
    };

    try {
      const response = await fetch(
        `${API_BASE_URL}${API_PATHS.uploadFile}`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`Upload failed with status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.status === 1 && data?.data?.location) {
        const uploadedimage = data.data.location;
        setimage(uploadedimage);
        setPreviewImage(uploadedimage); // Set preview image
        setErrors((prevErrors) => ({ ...prevErrors, image: "" }));
      } else {
        throw new Error(data.message || "Failed to upload image");
      }
    } catch (error) {
      console.error("Image Upload Error:", error.message);
      setImageError(
        error.message || "Something went wrong while uploading the image"
      );
    }
  }

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Ferry Service</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/ferry-services"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Ferry Services
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Ferry Service</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={addFerriess}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={handleChange}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  placeholder="Enter Ferry Name"
                />
                {errors.name && (
                  <div className="text-danger mt-2">{errors.name}</div>
                )}
              </div>

              <div className="col-md-5">
                <label className="form-label">
                  Image<span className="text-danger">*</span>
                </label>
                <br />
                <label htmlFor="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  name="image"
                  id="fileInput"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                />
                {errors.image && (
                  <div className="text-danger mt-2">{errors.image}</div>
                )}
                {previewImage && (
                  <div className="mt-3">
                    <img
                      src={previewImage}
                      alt="Uploaded Preview"
                      style={{ width: "50px", height: "auto" }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddFerries;
